import React from "react";
import { useQuantity } from "../../../Pregrine/CartPage/ProductListing/useQuantity";
import classes from "./quantity.module.css";

const Quantity = (props) => {
  const { itemId, initialValue, onChange } = props;

  const talonProps = useQuantity({ itemId, initialValue, onChange });

  const { quantity, setQuantity } = talonProps;

  return (
    <li>
      <h6 className="d-flex justify-content-center font-weight-bold">
        Quantity
      </h6>

      <div className={`input-group ${classes.input_group}`}>
        <input
          type="button"
          value="-"
          className={classes.button_minus}
          data-field="quantity"
          onClick={() => {
            if (quantity > 1) {
              setQuantity(quantity - 1);
            }
          }}
        />
        <input
          type="text"
          step="1"
          max=""
          value={quantity}
          name="quantity"
          className={classes.quantity_field}
          onInput={(event) => {
            event.target.value = event.target.value.replace(/[^0-9]/g, "");
            setQuantity(event.target.value);
          }}
          pattern="[0-9]*"
        />
        <input
          type="button"
          value="+"
          className={classes.button_plus}
          data-field="quantity"
          onClick={() => {
            setQuantity(quantity + 1);
          }}
        />
      </div>
    </li>
  );
};

export default Quantity;
